module.exports = __webpack_public_path__ + "media/assets/icons/zitensya_icon-5e91fa2607f8a4ae41bad2413c450200.svg";